<template lang="pug">
  span(data-testid="func-extract-card")
    button.btn.btn-success(type="button" @click="openModal" data-testid="-btn-split-card") 名刺分割

    //------------------------------------------------------------
    //- modals
    //------------------------------------------------------------
    portal(to="modal")
      //- 未選択
      app-modal(v-model="modalNoItem" type="info" data-testid="bcard-history-split-noitem-modal")
        template(slot="title") 未選択
        h4 名刺を1件以上選択してください。

      //- 確認
      app-modal(v-model="modalConf" type="primary" data-testid="bcard-history-split-conf-modal")
        template(slot="title") 確認
        h4 選択した名刺履歴を分割します。よろしいですか？
        p 分割された名刺履歴から、新しく別の人物が作成されます。
        template(slot="footer", slot-scope="{close}")
          button.btn.btn-primary(type="submit" @click="submit" data-testid="-btn-split") 分割
          button.btn.btn-default(type="button" @click="close") キャンセル

      //- 分割確認(over)
      app-modal(type="info", v-model="modalMaxerr" data-testid="bcard-history-split-all-modal")
        h4 すべての名刺履歴を一度に分割はできません。
        p 名刺履歴を選択する際、必ず 1 つ は未選択で残してください。
</template>

<script>
import AppModal from '@/components/templates/AppModal'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const MergePersonRepository = RepositoryFactory.get('mergeperson')

export default {
  name: 'FuncExtractCard',
  components: { AppModal },
  props: {
    sidPerson: { type: [Number, String], required: true, default: '' },
    checkedIds: { type: Array, required: false, default () { return [] } },
    maxLength: { type: Number, required: false, default: 0 }
  },
  data () {
    return {
      modalNoItem: false,
      modalConf: false,
      modalMaxerr: false
    }
  },
  computed: {
    countSelected () {
      return this.checkedIds.length
    }
  },
  methods: {
    /**
     * 分割確認モーダルを開く
     */
    openModal () {
      // 未選択エラー
      if (this.countSelected === 0) {
        this.modalNoItem = true
        return
      }
      // 全選択エラー
      if (this.countSelected === this.maxLength) {
        this.modalMaxerr = true
        return
      }
      this.modalConf = true
    },
    /**
     * 対象人物を分割する
     */
    submit () {
      const vm = this
      MergePersonRepository.extract({
        sid_person: this.sidPerson,
        sid_bcards: this.checkedIds
      })
        .then(function (response) {
          // 成功時
          if (vm.isApiSuccess(response)) {
            vm.showToast('名刺情報を分割しました。', { type: 'success' })
            vm.modalConf = false
            // 一覧更新
            vm.$store.dispatch('reloadBcardList')
          }
        })
        .catch(function (error) {
          const message = vm.getErrorMessage(error) || '名刺情報を分割できませんでした。'
          vm.showToast(message, { type: 'danger' })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/organisms/functions/FuncExtractCard.vue